module.exports = __webpack_public_path__ + "img/traveloka-form.fc80037.png";